import React, { useCallback, useMemo, useState } from "react";

import DatePickerContext from "nlib/ui/DatePicker/lib/DatePickerContext";
import DatePickerDays from "nlib/ui/DatePicker/lib/DatePickerDays";
import DatePickerMonths from "nlib/ui/DatePicker/lib/DatePickerMonths";
import DatePickerYears from "nlib/ui/DatePicker/lib/DatePickerYears";

const DAYS_VIEW = 0;

const MONTHS_VIEW = 1;

const YEARS_VIEW = 2;

const PAD_START = 2;

const getDataString = (parts) => parts.map((part) => String(part).padStart(PAD_START, "0")).join("-");

const DatePickerContent = (props) => {
  const {
    range,
    monthOnly,
    startDateObject,
    endDateObject,
    useOneMonth,
    setOpened,
    onChange
  } = props;

  const [view, setView] = useState(monthOnly ? MONTHS_VIEW : DAYS_VIEW);

  const [currentMonth, setCurrentMonth] = useState((startDateObject || new Date()).getMonth());

  const [currentYear, setCurrentYear] = useState((startDateObject || new Date()).getFullYear());

  const handleMonthSelect = useCallback((month) => {
    if (monthOnly) {
      onChange(getDataString([currentYear, month + 1, 1]));
    } else {
      setCurrentMonth(month);
      setTimeout(() => setView(DAYS_VIEW), 0);
    }
  }, [monthOnly, onChange, currentYear]);

  const handleDaySelect = useCallback(({ year, month, date }) => {
    onChange(getDataString([year, month + 1, date]));
  }, [onChange]);

  const providedContext = useMemo(() => ({
    startDateObject,
    endDateObject,
    currentMonth,
    currentYear,
    showCloseButton: !range || useOneMonth,
    setCurrentMonth,
    setCurrentYear,
    setDaysView: () => setTimeout(() => setView(DAYS_VIEW), 0),
    setMonthsView: () => setTimeout(() => setView(MONTHS_VIEW), 0),
    setYearsView: () => setTimeout(() => setView(YEARS_VIEW), 0),
    onClose: () => setOpened(false)
  }), [startDateObject, endDateObject, currentMonth, currentYear, range, useOneMonth, setOpened]);

  return (
    <>
      <DatePickerContext.Provider value={providedContext}>
        {(view === YEARS_VIEW)
          ? <DatePickerYears monthOnly={monthOnly} />
          : ((view === MONTHS_VIEW)
            ? <DatePickerMonths {...props} monthOnly={monthOnly} onSelect={handleMonthSelect} />
            : <DatePickerDays {...props} onSelect={handleDaySelect} />)}
      </DatePickerContext.Provider>
      {range && !useOneMonth && (
        <DatePickerContent
          {...props}
          range={false}
          secondView
          startDateObject={startDateObject}
          endDateObject={endDateObject}
          onChange={onChange} />
      )}
    </>
  );
};

export default React.memo(DatePickerContent);
